import { OpenOrPendingMatches } from "./OpenOrPendingMatches";
import { LiveMatches } from "./LiveMatches";
import { SummonIsland } from "./SummonIsland";
import { Header } from "./Header";
import { useStore } from "../../store";
import { InventorySidebar } from "./InventorySidebar";

export const AmalgemaUIRoot = () => {
  const layers = useStore((state) => {
    return {
      networkLayer: state.networkLayer,
    };
  });

  if (!layers.networkLayer) return <></>;

  return (
    <div
      className="relative grid"
      style={{
        gridTemplateColumns: "1fr 420px",
      }}
    >
      <div className="h-screen overflow-hidden">
        <Header />

        <div
          style={{
            background:
              "linear-gradient(152deg, rgba(244, 243, 241, 0.98) 0%, rgba(244, 243, 241, 0.88) 100%), url(/assets/ship-background.jpeg), lightgray -381.491px 0.145px / 126.42% 100% no-repeat",
            zIndex: -2,
          }}
          className="fixed top-0 left-0 h-screen w-screen bg-cover"
        />

        <div className="px-8 py-6 h-full overflow-y-auto">
          <SummonIsland />

          <div className="h-8" />
          <OpenOrPendingMatches />

          <div className="h-8" />
          <LiveMatches />

          <div className="h-20" />
        </div>
      </div>

      <InventorySidebar />
    </div>
  );
};
